import { render, staticRenderFns } from "./openended.vue?vue&type=template&id=fde8d73a&scoped=true&"
import script from "./openended.vue?vue&type=script&lang=js&"
export * from "./openended.vue?vue&type=script&lang=js&"
import style0 from "./openended.vue?vue&type=style&index=0&id=fde8d73a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde8d73a",
  null
  
)

export default component.exports